// extracted by mini-css-extract-plugin
export var item = "SupportItem-module--item--tr6pD";
export var supportButton = "SupportItem-module--supportButton--CPbGS";
export var innerButton = "SupportItem-module--innerButton--qllUk";
export var iconContainer = "SupportItem-module--iconContainer--FiQPp";
export var iconAside = "SupportItem-module--iconAside---feiI";
export var textContainer = "SupportItem-module--textContainer--y0QTK";
export var noIconItem = "SupportItem-module--noIconItem--UUu1W";